export default {
      id: "logo-usage",
      viewBox: "0 0 68 35",
      url: __webpack_public_path__ + "img/icons.31feac93.svg#logo",
      toString: function () {
        return this.url;
      }
    }